import { isEmpty, every, get, inRange, forEach } from 'lodash';
import { StartFlagIcon } from '../assets';

export function getJourneyMaps(state) {
  return state.journeyMaps;
}

export function getMyJourneyRoute(state, getters) {
  const journeyMaps = getters.getJourneyMaps;
  const myExperience = getters.getMyExperience;
  const MIN_REQUIRED_EXP = 6;

  if (isEmpty(journeyMaps)) return {};

  let myJourneyRoute = {
    mapIndex: 0,
  };

  if (!myExperience) {
    return {
      ...myJourneyRoute,
      ...get(journeyMaps, '[0].journey_routes[0]'),
    };
  }

  forEach(journeyMaps, (journeyMap, mapIndex) => {
    let isNextJourneyMap = true;
    forEach(journeyMap.journey_routes, (route, routeIndex) => {
      if (inRange(
        myExperience,
        route.required_exp,
      )) {
        myJourneyRoute = {
          ...journeyMap.journey_routes[routeIndex - 1],
          mapIndex,
        };

        if (myExperience < MIN_REQUIRED_EXP || routeIndex === 0) {
          myJourneyRoute = {
            ...journeyMap.journey_routes[routeIndex],
            mapIndex,
          };
        }
        isNextJourneyMap = false;
        return false;
      }

      return true;
    });

    return isNextJourneyMap;
  });

  return myJourneyRoute;
}

export function getMyJourneyMap(state, getters) {
  const journeyMaps = getters.getJourneyMaps;
  const myJourneyRoute = getters.getMyJourneyRoute;
  if (isEmpty(myJourneyRoute)) return journeyMaps[0];
  return journeyMaps[myJourneyRoute.mapIndex];
}

export function getMyJourneyState(state, getters) {
  const journeyMaps = getters.getJourneyMaps;
  const myJourneyRoute = getters.getMyJourneyRoute;

  if (isEmpty(journeyMaps)) return {};
  const journeyStages = get(journeyMaps[myJourneyRoute.mapIndex], 'journey_stages', []);
  let journeyState = {};

  every(journeyStages, (stage, index) => {
    if (inRange(
      myJourneyRoute.required_exp,
      stage.required_exp,
    )) {
      const prevJourneyState = (() => {
        if (!journeyStages[index - 1]) {
          return {
            icon: StartFlagIcon,
            required_exp: 0,
          };
        }

        return journeyStages[index - 1];
      })();

      journeyState = {
        prev: prevJourneyState,
        current: myJourneyRoute,
        next: stage,
      };

      return false;
    }

    return true;
  });

  return journeyState;
}
